function activateHeroBannerCarousel(){

    var heroBannerCarousels = document.querySelectorAll(".hero-banner-carousel-container")
    heroBannerCarousels.forEach(heroCarousel => {
        var carouselContainer = heroCarousel.querySelector(".carousel-container")
        var carousel = heroCarousel.querySelector(".carousel-slides")
        
        if(!carouselContainer)
            return

        var prevButton = heroCarousel.querySelector(".prev")
        var nextButton = heroCarousel.querySelector(".next")
        var carouselSlides = carouselContainer.querySelectorAll(".carousel-slide")
        var carouselTrackers = heroCarousel.querySelectorAll(".tracker-item")
        
        // ===============================================================
        // ================ Mobile Scroll Event Listeners ================
        // ===============================================================
        let startX = 0;
        // Detect Touch Start
        carousel.addEventListener("touchstart", (event) => {
            startX = event.touches[0].clientX; // Store initial touch position
        });

        // Detect Touch End (Trigger Action)
        carousel.addEventListener("touchend", (event) => {
            let endX = event.changedTouches[0].clientX; // Get final touch position
            let scrollDiff = endX - startX; // Calculate swipe distance

            if (scrollDiff > 30) {
                scrollToPreviousSlide()
            } else if (scrollDiff < -30) {
                scrollToNextSlide()
            }
        });
        // ===============================================================
        // ============== End Mobile Scroll Event Listeners ==============
        // ===============================================================


        // ===============================================================
        // ================ Desktop Scroll Event Listeners ===============
        // ===============================================================
        // Event listener for PREV scroll button
        prevButton.addEventListener("click", () => {
            scrollToPreviousSlide()
        });
        
        // Event listener for NEXT scroll button
        nextButton.addEventListener("click", () => {
            scrollToNextSlide()
        });
        // ===============================================================
        // ============== End Desktop Scroll Event Listeners =============
        // ===============================================================


        
        
        // ===============================================================
        // ===================== Set Periodic Scroll =====================
        // ===============================================================
        setInterval(() => {
            scrollToNextSlide();
        }, 5000);
        // ===============================================================
        // =================== End Set Periodic Scroll ===================
        // ===============================================================



        // ===============================================================
        // ==================== Scroll On Tracker Click ==================
        // ===============================================================
        carouselTrackers.forEach((trackerItem) => {
            trackerItem.addEventListener("click", () => {
                for (let i = 0; i < carouselTrackers.length; i++) {
                    if(carouselTrackers[i] == trackerItem){
                        scrollToIndex(i)
                        break;
                    }
                    
                }
                
            });
        })

        // ===============================================================
        // ==================== Scroll On Tracker Click ==================
        // ===============================================================

        function scrollToIndex(targetIndex){
            var activeIndex = parseInt(heroCarousel.querySelector(".carousel-slide.active").dataset.slideIndex)

            // add "active" class to corresponding slide, and remove it from previous slide
            carouselSlides[activeIndex].classList.remove("active")
            carouselSlides[targetIndex].classList.add("active")

            // highlight active tracker
            carouselTrackers[activeIndex].classList.remove("active")
            carouselTrackers[targetIndex].classList.add("active")

            // scroll the carousel
            const offsetLeft = carouselSlides[targetIndex].offsetLeft;
            carousel.scrollTo({ left: offsetLeft, behavior: 'smooth' });
        }
        

        function scrollToPreviousSlide(){
            var activeIndex = parseInt(heroCarousel.querySelector(".carousel-slide.active").dataset.slideIndex)

            var prevIndex = activeIndex - 1
            if (prevIndex == -1){
                prevIndex = carouselSlides.length - 1
            }

            // add "active" class to corresponding slide, and remove it from previous slide
            carouselSlides[activeIndex].classList.remove("active")
            carouselSlides[prevIndex].classList.add("active")

            // highlight active tracker
            carouselTrackers[activeIndex].classList.remove("active")
            carouselTrackers[prevIndex].classList.add("active")

            // scroll the carousel
            const offsetLeft = carouselSlides[prevIndex].offsetLeft;
            carousel.scrollTo({ left: offsetLeft, behavior: 'smooth' });
        }

        function scrollToNextSlide(){
            var activeIndex = parseInt(heroCarousel.querySelector(".carousel-slide.active").dataset.slideIndex)
            
            var nextIndex = activeIndex + 1
            if (nextIndex == carouselSlides.length){
                nextIndex = 0
            }
            
            // add "active" class to corresponding slide, and remove it from previous slide
            carouselSlides[activeIndex].classList.remove("active")
            carouselSlides[nextIndex].classList.add("active")

            // highlight active tracker
            carouselTrackers[activeIndex].classList.remove("active")
            carouselTrackers[nextIndex].classList.add("active")

            // scroll the carousel
            const offsetLeft = carouselSlides[nextIndex].offsetLeft;
            carousel.scrollTo({ left: offsetLeft, behavior: 'smooth' });
        }
    })
}

window.addEventListener("load", function() {
    try {
        activateHeroBannerCarousel();
    } catch (error) {
        console.error("Error in activateHeroBannerCarousel:", error);
    }
})